<template>
  <div>
    <el-dialog
      title="添加到专题"
      :visible.sync="show"
      class="top-draft-dialog"
      :before-close="handleClose"
    >
      <div class="card">
        <div class="col-lg-12 list-header fix-header clearfix">
          <div class="dsply-fix fix-header-item">
            <b-form-input
              v-model="pageParams.userName"
              class="w-190 m-r-10"
              size="sm"
              type="text"
              placeholder="搜索标题"
            ></b-form-input>
            <b-button
              class="m-r-5"
              size="sm"
              variant="primary"
              @click="search()"
            >
              <i class="bx bx-search-alt-2 font-size-16 align-middle"></i>
              搜索
            </b-button>
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="resetParams()"
            >
              <i class="bx bx-revision font-size-16 align-middle"></i>
              重置
            </b-button>
          </div>
        </div>
        <div class="table-responsive-main-list">
          <div class="table-responsive">
            <table class="table align-middle table-nowrap table-hover">
              <thead class="table-light">
                <tr>
                  <th scope="col" style="width: 70px;"></th>
                  <th scope="col" style="width: 70px;">ID</th>
                  <th scope="col">标题</th>
                  <th scope="col">封面</th>
                  <th scope="col">创建时间</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td class="media-dialog-radio">
                    <el-radio v-model="showState" :label="item.id"></el-radio>
                  </td>
                  <td>{{ item.id }}</td>
                  <td class="w-300px white-inherit">{{ item.nickname }}</td>
                  <td>
                    <img
                      v-if="item.avatar"
                      class="w-3-rem"
                      :src="`${item.avatar}`"
                      alt
                    />
                    <img
                      v-if="!item.avatar"
                      class="w-3-rem"
                      src="@/assets/images/image-null.jpg"
                      alt=""
                    />
                  </td>
                  <td>{{ item.updatedAt || "--" }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="row submit-bar">
          <div class="col-md-12">
            <div class="bar-handle">
              <button
                @click="handleClose()"
                class="btn-sm btn btn-outline-dark"
                type="button"
              >
                取消
              </button>
              <button
                @click="submitCreate()"
                class="btn-sm btn btn-primary"
                type="button"
              >
                确定
              </button>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from "vue";
import Swal from "sweetalert2";
import article from "@/server/api/article";

export default {
  components: {},

  data() {
    return {
      pageParams: {
        userName: "",
      },
      showState: "",
      items: [],
      show: false,
    };
  },

  props: {},

  mounted() {},

  methods: {
    showModel() {
      this.resetParams();
      this.show = true;
    },

    handleClose() {
      this.show = false;
    },

    //获取列表数据
    getList() {
      let params = this.utils.getQuery(this.pageParams);
      article.mediaList(params).then((resp) => {
        if (resp.code == 0) {
          if (resp.data) {
            this.items = resp.data;
          }
        }
      });
    },

    submitCreate() {
      let current = {
        code: "media",
        item: {},
      };
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].id == this.showState) {
          current.item = this.items[i];
        }
      }
      this.handleClose();
      this.$emit("pageCallback", current);
    },

    //搜索
    search() {
      this.pageParams.page = 1;
      this.getList();
    },

    //重置搜索参数
    resetParams() {
      this.pageParams.page = 1;
      this.pageParams.userName = "";
      this.getList();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
.top-draft-dialog .el-dialog {
  width: 890px;
  border-radius: 6px;
  margin-top: 0 !important;
  position: fixed;
  top: 50%;
  left: 50%;
  -webkit-transform: translateX(-50%) translateY(-50%);
  -moz-transform: translateX(-50%) translateY(-50%);
  -ms-transform: translateX(-50%) translateY(-50%);
  transform: translateX(-50%) translateY(-50%);
  max-height: 90vh;
}



















</style>
